import React from 'react';
import { Link } from 'react-router-dom';

import { Link as MuiLink, Typography } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import * as api from '_core/utils/api';
import { Price } from '_core/components/Price';
import NoteView from '_core/components/NoteView';


const VisitorStatus = ({ l, value }) => {
  const statuses = api.useClassicVisitorStatus();
  
  
  const type = Array.isArray(value) && Number(value[0]) || 1;
  const id = Array.isArray(value) && Number(value[1]) || 0;
  
  if (statuses.isLoading) {
    return <Skeleton animation="wave" variant="rect" />;
  } else if (!Array.isArray(statuses.data)) {
    return id;
  } else {
    const status = statuses.data.find((item) => item.id === id && item.type === type);
    
    if (!status)
      return id;
    
    return l(status.title);
  }
};


export { StructureInfo } from './StructureInfo';

export const renderProp = (l, prop) => (
  prop.type === 2 || prop.type === 'multiline' ? <NoteView>{String(prop.value?.title ?? prop.value ?? '')}</NoteView> : 
  prop.type === 'record' ? String(prop.value?.title ?? prop.value ?? '') : 
  prop.type === 'bool' ? prop.value ? l('global.field.yes') : l('global.field.no') : 
  prop.type === 'lang' ? l(prop.value?.startsWith('$') ? prop.value.substring(1) : prop.value) : 
  prop.type === 'price' && prop.value?.currency ? <Price simple value={prop.value.value} currency={prop.value.currency.id} /> : 
  prop.type === 'header' ? <Typography variant="h6">{prop.title}</Typography> : 
  prop.type === 'link' ? prop.blank ? <MuiLink href={prop.value} target="_blank">{prop.title}</MuiLink> : <Link to={prop.value}>{prop.title}</Link> : 
  prop.type === 'status' ? <VisitorStatus l={l} value={prop.value} /> : 
  String(prop.value ?? '-')
) ?? '-';
